import React from 'react'
import Img from '../../shared/Img'
import SEO from './consts'
import WithSeoOverrides from 'src/components/shared/WithSeoOverride'

const PartnerWithTheLeader = () => (
  <>
    <WithSeoOverrides {...SEO} />
    <div
      className="max-w-1400 bg-gray-160 px-2 py-6 text-center md:mx-auto md:px-2 md:pt-40 md:pb-5"
      data-testid="header"
    >
      <h1
        className="text-1.5xl font-semibold text-blue-700 md:mb-5 md:text-4xl"
        data-testid="title"
      >
        Partner With the Leader in Debt Resolution
      </h1>
      <p
        className="mx-auto text-sm text-gray-400 md:w-140 md:text-lg"
        data-testid="subtitle"
      >
        Learn what to expect when you enroll in the FDR program.
      </p>
    </div>
    <div className="flex flex-col justify-center px-2 py-8">
      <a
        href="https://s3.amazonaws.com/freedomdebtrelief.com/fdr_sales_sheet_partner.pdf"
        className="pb-3 text-center text-sm"
      >
        Click here to download this document now
      </a>
      <div className="mx-auto">
        <Img
          width={612}
          height={792}
          layout="intrinsic"
          src="/next-assets/fdr_sales_sheet_partner.webp"
          alt="Partner With the Leader in Debt Resolution"
          styles={{ position: 'relative' }}
        />
      </div>
    </div>
  </>
)

export default PartnerWithTheLeader
